"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pop3Settings = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
//@ts-ignore                
let rwsTemplate = T.html `<div class="pop3-settings">
    <div class="form-row mb-3">
        <div class="form-group col-md-6">
            <part-switch class="form-part" label="${'whatsapp.settings.pop3.isGmail.label'.t()}" :value="${x => x.isGmail}" name="pop3IsGmail"></part-switch>
            <div class="form-text">${'whatsapp.settings.pop3.isGmail.hint'.t()}</div>
        </div>
        <div class="form-group col-md-6">
            <part-switch class="form-part" label="${'whatsapp.settings.pop3.enabled.label'.t()}" :value="${x => x.enabled}" name="pop3Enabled"></part-switch>
        </div>
    </div>

    ${(0, fast_element_1.when)(x => !x.isGmail, (0, fast_element_1.html) `
    <div class="form-row">
        <div class="form-group col-md-6">
            <part-input class="form-part" label="${'whatsapp.settings.pop3.host.label'.t()}" :value="${x => x.host}" name="pop3Host" placeholder="${'whatsapp.settings.pop3.host.placeholder'.t()}"></part-input>
        </div>
        <div class="form-group col-md-2">
            <part-input class="form-part" label="${'whatsapp.settings.pop3.port.label'.t()}" :value="${x => x.port}" name="pop3Port" type="number" placeholder="993"></part-input>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-6">
            <part-input class="form-part" label="${'whatsapp.settings.pop3.username.label'.t()}" :value="${x => x.username}" name="pop3Username" placeholder="${'whatsapp.settings.pop3.username.placeholder'.t()}"></part-input>
        </div>
        <div class="form-group col-md-6">
            <div class="d-flex align-items-end">
                <div class="flex-grow-1">
                    <part-input class="form-part" label="${'whatsapp.settings.pop3.password.label'.t()}" :value="${x => x.password || ''}" name="pop3Password" type="${x => x.passwordVisible ? 'text' : 'password'}" placeholder="${'whatsapp.settings.pop3.password.placeholder'.t()}"></part-input>
                </div>
                <button type="button" class="btn btn-outline-secondary btn-sm ml-2 mb-1" @click="${x => x.togglePasswordVisibility()}">
                    <i class="simple-icon-${x => x.passwordVisible ? 'lock' : 'eye'}"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-6">
            <part-switch class="form-part" label="${'whatsapp.settings.pop3.useTls.label'.t()}" :value="${x => x.useTls}" name="pop3UseTls"></part-switch>
        </div>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => x.isGmail, (0, fast_element_1.html) `
    <div class="alert alert-info">
        <i class="simple-icon-info mr-2"></i>
        ${'whatsapp.settings.pop3.gmail.info'.t()}
    </div>
    `)}
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let Pop3Settings = class Pop3Settings extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.host = '';
        this.port = 993;
        this.username = '';
        this.password = '';
        this.useTls = true;
        this.enabled = true;
        this.passwordVisible = false;
        this.isGmail = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            event.stopPropagation();
            this.handleFieldChange(event.detail.fieldName, event.detail.value);
        });
    }
    resetForm() {
        this.host = '';
        this.port = 993;
        this.username = '';
        this.password = '';
        this.useTls = true;
        this.enabled = true;
        this.isGmail = false;
    }
    getData() {
        return {
            host: this.host,
            port: this.port,
            username: this.username,
            password: this.password,
            useTls: this.useTls,
            enabled: this.enabled,
            isGmail: this.isGmail
        };
    }
    setData(settings) {
        if (settings && settings.length > 0) {
            const s = settings[0];
            this.host = s.host || '';
            this.port = s.port || 993;
            this.username = s.username || '';
            this.password = s.password || '';
            this.useTls = s.useTls !== false;
            this.enabled = s.enabled !== false;
            this.isGmail = s.isGmail || false;
        }
    }
    handleFieldChange(fieldName, value) {
        switch (fieldName) {
            case 'pop3Host':
                this.host = value;
                break;
            case 'pop3Port':
                this.port = parseInt(value, 10) || 993;
                break;
            case 'pop3Username':
                this.username = value;
                break;
            case 'pop3Password':
                this.password = value;
                break;
            case 'pop3UseTls':
                this.useTls = value;
                break;
            case 'pop3Enabled':
                this.enabled = value;
                break;
            case 'pop3IsGmail':
                this.isGmail = value;
                break;
        }
        this.emitChange();
    }
    togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
    }
    emitChange() {
        this.$emit('pop3-settings-changed', { settings: this.getData() });
    }
};
exports.Pop3Settings = Pop3Settings;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], Pop3Settings.prototype, "host", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], Pop3Settings.prototype, "port", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], Pop3Settings.prototype, "username", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], Pop3Settings.prototype, "password", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], Pop3Settings.prototype, "useTls", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], Pop3Settings.prototype, "enabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], Pop3Settings.prototype, "passwordVisible", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], Pop3Settings.prototype, "isGmail", void 0);
exports.Pop3Settings = Pop3Settings = __decorate([
    (0, client_1.RWSView)('pop3-settings', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], Pop3Settings);
Pop3Settings.defineComponent();
